import React from "react";
import { useDrag, useDrop } from "react-dnd";
import BCCard from "./BCCard";

const style = {
  marginBottom: "10px",
  cursor: "move",
};

export interface CardProps {
  id: string;
  index: number;
  card: any;
  category: number;
  cards: any;
  moveCard: (card: any, draggedIndex: number, overIndex: number, draggedCategoryIndex: number, overCategoryIndex: number) => void;
  findCard: (id: string, category: number) => { index: number };
  ellipsis?: any;
  labels?: any;
  displayList?: any;
  handleInfo?: any;
  handleExport?: any;
  handleApplication?: any;
  handleCopyApplication?: any;
  handleSummary?: any;
  handleGMR?: any;
  handleCopyGMR?: any;
  ellipsisHandlers?: any;
}

const BCKanbanCard: React.FC<CardProps> = ({ 
  id, 
  index, 
  card, 
  category, 
  cards, 
  moveCard, 
  findCard,
  ellipsis,
  labels,
  displayList,
  handleInfo,
  handleExport,
  handleApplication,
  handleCopyApplication,
  handleSummary,
  handleGMR,
  handleCopyGMR,
  ellipsisHandlers
}) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const originalIndex = findCard(id, category).index;
  const [{ isDragging }, drag] = useDrag({
    item: { type: "card", id, originalIndex },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    end: () => void 0,
  });

  const [, drop] = useDrop({
    accept: "card",
    canDrop: () => false,
    hover(item: any, monitor: any) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.originalIndex;
      const hoverIndex = index;

      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }

      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect();

      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

      // Determine mouse position
      const clientOffset = monitor.getClientOffset();

      // Get pixels to the top
      const hoverClientY = (clientOffset as any).y - hoverBoundingRect.top;

      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }

      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }

      // Time to actually perform the action
      const draggedCategory = cards.find(x => {
        return x.cards.find(y => y.id === item.id);
      });
      const draggedCard = draggedCategory.cards.find(x => x.id === item.id);
      const draggedIndex = draggedCategory.cards.indexOf(draggedCard);
      moveCard(draggedCard, draggedIndex, hoverIndex, draggedCategory.index, category);
      item.originalIndex = hoverIndex;
    },
  });

  const opacity = isDragging ? 0 : 1;
  drag(drop(ref));
  return (
    <div className="ui cards landing-page-cards" ref={ref} style={{ ...style, opacity }}>
      <BCCard
        key={`bc-card-${index}`}
        isGreaterThanMobile={true}
        infoData={cards}
        displayList={displayList} 
        handleInfo={handleInfo}
        handleExport={handleExport}
        handleApplication={handleApplication}
        handleCopyApplication={handleCopyApplication}
        handleSummary={handleSummary}
        handleGMR={handleGMR}
        handleCopyGMR={handleCopyGMR}
        ellipsis={ellipsis}
        labels={labels}
        isKanban={false}
        item={card}
        i={index}
        ellipsisHandlers={ellipsisHandlers}
      />
    </div>
  );
};

export default BCKanbanCard;